export default __webpack_public_path__ + "54e4e4f.png";